import React from "react";
import { ChatIcon } from "components/icons/LeftNav/ChatIcon";
import { CellContext } from "react-table-8.10.7";
import { Broadcast } from "types/Models/broadcastCall";
import { Mail } from "components/icons/Mail";
import { CallFromChatIcon } from "components/icons/Chat/CallFromChatIcon";
import classNames from "classnames";
import ConditionalToolTip from "components/design/conditionalToolTip";
import {
  BROADCAST_TYPES,
  BULK_CALL_CAMPAIGN_STATUSES,
} from "constants/broadcast";
import { WhatsApp } from "components/icons/WhatsApp";

export const BroadcastMedium = (info: CellContext<Broadcast, string[]>) => {
  const mediums = info.getValue() || [];
  const ivrStats = info.row.original.ivr_stats;
  const hasIvrStats = ivrStats && Object.keys(ivrStats).length > 0;

  return (
    <div className="t-flex t-gap-2 t-items-center">
      <WhatsApp
        className={classNames("t-h-5 t-w-5", {
          "t-text-green-90": mediums.includes(BROADCAST_TYPES.WHATSAPP),
          "t-text-neutral-20": !mediums.includes(BROADCAST_TYPES.WHATSAPP),
        })}
      />
      <ChatIcon
        className={classNames("t-h-5 t-w-5 t-font-bold", {
          "t-text-green-90": mediums.includes(BROADCAST_TYPES.CHAT),
          "t-text-neutral-20": !mediums.includes(BROADCAST_TYPES.CHAT),
        })}
      />
      <Mail
        className={classNames("t-h-5 t-w-5", {
          "t-text-green-90": mediums.includes(BROADCAST_TYPES.EMAIL),
          "t-text-neutral-20": !mediums.includes(BROADCAST_TYPES.EMAIL),
        })}
      />
      <ConditionalToolTip
        condition={
          hasIvrStats && (
            <div className="t-text-left">
              <div className="t-text-body-sm t-text-surface t-font-bold">
                IVR Stats:
              </div>
              <br />
              {ivrStats.campaign_status ===
              BULK_CALL_CAMPAIGN_STATUSES.SCHEDULED ? (
                <div className="t-text-body-sm t-text-neutral-30 t-flex t-gap-1">
                  Calls scheduled:
                  <div className="t-font-bold t-text-surface">
                    {ivrStats.scheduled_calls}
                  </div>
                </div>
              ) : (
                <>
                  <div className="t-text-body-sm t-text-neutral-30 t-flex t-gap-1">
                    Calls picked:
                    <div className="t-font-bold t-text-surface">
                      {ivrStats.successful_calls}
                    </div>
                  </div>
                  <div className="t-text-body-sm t-text-neutral-30 t-flex t-gap-1">
                    Calls declined:{" "}
                    <div className="t-font-bold t-text-surface">
                      {ivrStats.missed_calls}
                    </div>
                  </div>
                  <div className="t-text-body-sm t-text-neutral-30 t-flex t-gap-1">
                    Not connected:{" "}
                    <div className="t-font-bold t-text-surface">
                      {ivrStats.failed_calls}
                    </div>
                  </div>
                </>
              )}
            </div>
          )
        }
      >
        <span>
          <CallFromChatIcon
            className={classNames("t-h-5 t-w-5", {
              "t-text-green-90": mediums.includes(BROADCAST_TYPES.IVR),
              "t-text-neutral-20": !mediums.includes(BROADCAST_TYPES.IVR),
            })}
          />
        </span>
      </ConditionalToolTip>
    </div>
  );
};
